<template>
  <div class="page">
    <div class="breakout">
      <div class="content-container">
        <span>{{ "store_list.header.span" | translate }}</span>
        <h1 class="text-gradient purple">
          {{ "store_list.header.h1" | translate }}
        </h1>
        <p>{{ "store_list.header.p" | translate }}</p>
      </div>
    </div>
    <div class="content-container">
      <div v-if="isParsed" class="brand-section">
        <div
          class="brand-container"
          v-for="(brandGroup, key) in parsedBrands"
          :key="key"
        >
          <h3 class="brand-key">{{ key }}</h3>
          <div
            v-for="(brand, j) in brandGroup"
            :key="j"
            @click="onBrandClick(brand)"
          >
            <span class="brand">{{ brand }}</span>
          </div>
        </div>
      </div>
      <gyra-spinner v-else />
    </div>
  </div>
</template>

<script>
import { getPossibleFilterValues } from "../services/api";
import GyraSpinner from "../components/atoms/gyra-spinner";
import { mapMutations } from "vuex";
export default {
  name: "BrandPage.vue",
  components: { GyraSpinner },
  data() {
    return {
      brands: null,
      parsedBrands: {},
      isParsed: false
    };
  },
  methods: {
    async getBrands() {
      const response = await getPossibleFilterValues("brand");
      if (response.status === 200) {
        this.brands = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    parseBrands() {
      this.brands.forEach(brand => {
        let key;
        if (!brand) {
          return;
        } else if (/^\d/.test(brand)) {
          key = "123";
        } else {
          key = brand[0].toUpperCase();
        }
        if (!(key in this.parsedBrands)) {
          this.parsedBrands[key] = [];
        }
        this.parsedBrands[key].push(brand);
      });
      this.isParsed = true;
    },
    onBrandClick(brand) {
      this.setFieldByKeyValue({ key: "brand", value: [brand] });
      this.$router.push({ name: "ProductMap" });
    },
    ...mapMutations({
      setFieldByKeyValue: "filters/setFieldByKeyValue"
    })
  },
  async beforeMount() {
    await this.getBrands();
    this.parseBrands();
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.breakout {
  background-color: $brand-gray-light;
  padding: 5rem 0;

  .content-container {
    text-align: center;

    span {
      display: block;
    }

    h1 {
      font-size: 4.5rem;
    }

    span,
    h1 {
      margin-bottom: 2rem;
      white-space: pre-wrap;
    }
  }
}

.brand-section {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  .brand-container {
    width: 100%;
    margin-bottom: 2rem;
    padding-right: 1rem;

    @media (min-width: $breakpoint-sm) {
      width: 50%;
    }

    @media (min-width: $breakpoint-md) {
      width: 33.3%;
    }

    @media (min-width: $breakpoint-lg) {
      width: 25%;
    }
  }

  .brand-key {
    font-size: $font-xxxl;
    font-family: "Lora";
    border-bottom: 2px solid $brand-gray-light;

    @media (min-width: $breakpoint-sm) {
      border: none;
    }
  }

  .brand {
    font-size: $font-sm;
    width: 100%;
    cursor: pointer;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
}
.hidden {
  display: none !important;
}
</style>
